import {useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { LINKS } from '../../../../Routs/config'
import { SwipeableListItem } from '../../../../generic/swipe/SwipeableListAdapter'
import SwipeContent from '../knisot/Components/SwipeContent'
import TitleLayout from '../kosherTeudot/generic/TitleLayout'
import TitleRow from '../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../kosherTeudot/generic/TitleRowItem'
import UserIcon from '../../../../generic/icons/IconLib/UserIcon'
import PalletIcon from '../../../../generic/icons/IconLib/PalletIcon'
import CalendatDay from '../../../../generic/icons/IconLib/CalendarIcon'
import DivideIcon from '../../../../generic/icons/IconLib/DivideIcon'
import InvoiceIcon from '../../../../generic/icons/IconLib/InvoiceIcon'
import LocationIcon from '../../../../generic/icons/IconLib/MapPinIcon'
import PrintIcon from '../../../../generic/icons/IconLib/PrintIcon'
import { convertToDate } from '../../../../modules/convertDateString'
import styled from 'styled-components'
import ConfirmDelate from './Components/ConfirmDelate'
import { useTranslation } from 'react-i18next'

export default function ControlPalletsTitle({
  selectClientFunc, Pallet_Num, CustomerDesc, 
  Pallet_Date, TranzitDesc, onClick, handleDelete,
  printPallet, Delivery_Num, ExtermalNum, 
  handleSelectPalletTitle, item
}) {
  const [t] = useTranslation('controllPallet')
  const [isOpenDelate, setIsOpenDelate] = useState(false)
  const [isDelated, setIsDelated] = useState(false)
  const navigate = useNavigate()
  const date = convertToDate(Pallet_Date)
  const handleAction = () => {
    selectClientFunc(CustomerDesc)
    navigate(`${LINKS.mishtahim.control.create}${Pallet_Num}`)
  }
  const handleOpenConfirm = () => {
    setIsOpenDelate(!isOpenDelate)
  }
  const handleClickDividePallet = () => {
    handleSelectPalletTitle(item)
  }
  const handleDeleteItem = () => {
    setIsDelated(true)
    return new Promise((resolve, reject) => {
      resolve(
        setTimeout(() => {
          handleDelete(Pallet_Num)
          
        }, 500)
      )
      reject(
        setTimeout(() => {
          setIsDelated(false)
          setIsOpenDelate(false)
        }, 500)
      )
    })
  }
  const handlePrint = () => {
    printPallet(Pallet_Num)
  }
  return (
      <TitleLayout isDraggable isDelete={isDelated} borderColor={Delivery_Num !== 0 && '#80E081'}> 
        <SwipeableListItem
            swipeRight={{
              content: <SwipeContent text={t('controllPallet_update')} />,
              action: handleAction,
            }}
            swipeLeft={{
              content: <SwipeContent text={t('controllPallet_delete')} isPrimal position='right' />,
              action: handleOpenConfirm
            }}
            threshold={0.4}
        >
          <TitleLayout disableShadow>
            <IconsContainer>
              <SideIconWrapper onClick={handlePrint}>
                <PrintIcon />
              </SideIconWrapper>
              {
                Delivery_Num === 0 && (
                  <SideIconWrapper onClick={handleClickDividePallet}>
                    <DivideIcon />
                  </SideIconWrapper>
                )
              }
              
            </IconsContainer>

              <TitleRow>
                <TitleRowItem icon={<UserIcon fill />} name={CustomerDesc.trim()} />
              </TitleRow>
              <TitleRow>
                <TitleRowItem icon={<CalendatDay fill />} name={date} />
                <TitleRowItem icon={<PalletIcon fill />} name={(ExtermalNum ? `(${ExtermalNum}) ` : '') + `${Pallet_Num}`} />
              </TitleRow>
              <TitleRow>
                {
                  Delivery_Num !== 0 && (
                    <TitleRowItem icon={<InvoiceIcon />} name={Delivery_Num} />
                  )
                }
                <TitleRowItem icon={<LocationIcon />} name={TranzitDesc} />
              </TitleRow>
          </TitleLayout> 
          {
            isOpenDelate &&
            <ConfirmDelate
              handleClick={handleDeleteItem}
            />
          }
        </SwipeableListItem>
      </TitleLayout>
  )
}

const IconsContainer = styled.div`
  position: absolute;
  top: calc(50% - 1.5em);
  display: flex;
  gap: 0.5em;
`

const SideIconWrapper = styled.div`
  width: 3em;
  /* background-color: red; */
  color: #297F76;
  height: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3em;
  cursor: pointer;
  &:hover {
    svg {
      color: tomato;
    }
  }
  @media screen and (max-width: 768px) {
    width: 1em;
  }
`
